import React, { useContext, useMemo, useReducer } from 'react';

import { initialState, instituteReducer, instituteProp } from '@/common';

export interface ContextType {
  state: instituteProp;
  dispatch: (action: any) => void;
}
const AppContext = React.createContext<ContextType>({} as ContextType);
export const ContextWrapper = ({ children }: any) => {
  const [state, dispatch] = useReducer(instituteReducer, initialState);
  const contextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  return <AppContext.Provider value={contextValue as any}>{children}</AppContext.Provider>;
};
export const useAppContext = () => {
  return useContext(AppContext);
};
